import axios from "axios";

const BASE_URL = process.env.REACT_APP_SERVER;

const endpoints = {
  default: "/api/v1/customers",
  allCustomers: "/all_customers",
};

export async function getAllCustomers({ eventID, page, limit, apiKey }) {
  const requestUrl =
    BASE_URL +
    endpoints.default +
    endpoints.allCustomers +
    `?event_id=${eventID}&limit=${limit}&skip=${(page - 1) * limit}`;

  const config = {
    method: "get",
    url: requestUrl,
    headers: {
      "x-api-key": apiKey,
    },
  };

  try {
    const response = await axios(config);

    return response;
  } catch (err) {
    console.log(err);
    return { error: err.response.data };
  }
}

export function getCustomer({ customerID, apiKey }) {
  const requestUrl =
    BASE_URL + endpoints.default + `?customer_contact=${customerID}`;

  return axios({
    method: "get",
    url: requestUrl,
    headers: {
      "x-api-key": apiKey,
    },
  });
}
